import React, { Component } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import PostData from '../../Services/ServAuthentication';
import TextField from 'material-ui/TextField';
import './Login.css';
import LogoLogin from '../../Assets/Images/loginlogo.png';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import '../Requests/Add/AddRequests.css';
import RefreshIndicator from 'material-ui/RefreshIndicator';

const muiTheme = getMuiTheme({
  fontFamily: 'Open Sans',
});

const style = {
  container: {
    position: 'relative',
  },
  refresh: {
    display: 'inline-block',
    position: 'relative',
  },
};


class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
      invalidUserNameOrPassword: false,
      logOutMessage: false,
      loading: false,
    };

    this.login = this.login.bind(this);
    this.onChange = this.onChange.bind(this);
    this.approveAuthentication = this.approveAuthentication.bind(this);

  }

  approveAuthentication(data) {
    this.props.setAuthentication(true, data, () => {
      if (this.props.isAuthenticated) {
        this.props.history.push('/request/list');
        localStorage.setItem('userToken', JSON.stringify(data.token))
        localStorage.setItem('data', JSON.stringify(data));
      }
    })
  }

  login() {

    if (this.state.username && this.state.password) {
      this.setState({ loading: true })
      PostData('login', this.state).then((data) => {
        this.approveAuthentication(data);
      }).catch((err) => {
        this.setState({ invalidUserNameOrPassword: true, loading: false })
      });
    }
  }


  componentDidMount() {
    document.title = "Cool Beer | Cold Drink Service";
    this.nameInput.focus();


  }



  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }




  render() {
    // Styles.
    const loginInfo = {
      display: "block",
      margin: "auto",
      marginBottom: 20,
      fontSize: 18
    };

    const loginInputStyle = {
      color: '#55aef6',
      borderColor: '#55aef6'
    };

    let loader = null;

    if (this.state.loading) {
      loader = <div className="loader-login">
        <RefreshIndicator
          size={40}
          left={10}
          loadingColor="#90caf9"
          top={20}
          status="loading"
          style={style.refresh}
        />
      </div>
    }

    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div className="main-login-wraper ">
          <div className="ui--video-background-holder ">
            <div className="ui--video-background-video hidden-phone ">
              <video autoPlay="autoplay" loop="loop" muted="muted" className="ui--filled" >
                <source src="https://0.s3.envato.com/h264-video-previews/3f56531e-3976-11e3-8c19-00505692144f/5905374.mp4" type="video/mp4" />
                <source src="https://envision.wptation.com/wp-content/uploads/2014/01/5905374.webmhd.webm" type="video/webm" />
              </video>
              <div>
                <div className="ui--video-background-poster"></div>
                <div className="ui--video-background">
                  <div className="ui--gradient"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="loginForm">
            <div className="loginForm-inner login-wraper">
              {loader}
              <img src={LogoLogin} className="login-logo" alt="cool beer" />
              <p className="login-title">Cold drink service</p>
              <p className="login-subtitle">Client login</p>

              <TextField floatingLabelFocusStyle={loginInputStyle} underlineFocusStyle={loginInputStyle} name="username" type="text" style={loginInfo} floatingLabelFixed={true} floatingLabelText={"Korisničko ime:"} onChange={this.onChange}
                ref={(input) => { this.nameInput = input; }}
              />
              <TextField
                onKeyPress={(event) => {
                  if (event.key === 'Enter') {
                    this.login();
                    event.preventDefault();
                  }
                }}
                id="login-submit" floatingLabelFocusStyle={loginInputStyle} underlineFocusStyle={loginInputStyle} name="password" style={loginInfo} type="password" floatingLabelFixed={true} floatingLabelText={"Lozinka:"} onChange={this.onChange} />
              {this.state.invalidUserNameOrPassword ? <div className="login-invalid-credentials" > <p>Pogrešno korisničko ime ili lozinka.</p><p>Molimo pokušajte ponovo</p> </div> : null}
              <RaisedButton
                onClick={this.login}
                label={"Prijavi se"}
                style={{ marginLeft: 20, marginRight: 20, display: "block" }}
                backgroundColor="#90caf9"
                labelColor="#ffffff"
              />
              <NavLink to={"/reset-password"} className="login-password">Zaboravili ste lozinku?</NavLink>
            </div>
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/Components/Login/Login.jsx